import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useInsurerProvider } from '../Insurer.Hooks';

export default function InsurerDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useInsurerProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.displayInfo.title}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
